import React from "react";
import { useState } from "react";

import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import ListGroup from "react-bootstrap/ListGroup";
import Button from "react-bootstrap/Button";

function Task() {
  // Define initial state
  const [showAddEditForm, setShowAddEditForm] = useState(false);
  const [showTaskList, setShowTaskList] = useState(true);
  const [showAddButton, setShowAddButton] = useState(true);
  
  const [taskTitle, setTaskTitle] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [statusMessage, showStatusMessage] = useState("");
  const [taskToBeEdited, setTaskToBeEdited] = useState(null);
  const [toggleAddEditTask, setToggleAddEditTask] = useState(true); // add = true, edit = false
  
  // Default array of tasks
  const [tasks, setTasks] = useState([
    {
      id: "1",
      title: "Pre-Cooking Tasks",
      description: "Season the rib roast with salt and let it rest to come to room temperature. Preheat the oven to 500 degrees. Rub the roast with seasoning mix of garlic, salt, pepper, rosemary, thyme, and olive oil. Place oven-safe meat thermometer into thickest part of the meat."
    },
    {
      id: "2",
      title: "Cooking Tasks",
      description: "Bake in oven at 500 degrees for 15 minutes. Reduce heat to 325 degrees and continue baking for 13-14 minutes per pound for medium rare. Roast until meat thermometer reaches 125-130 degrees for medium rare."
    },
    {
      id: "3",
      title: "Post-Cooking Tasks",
      description: "Remove roast from oven, tent it with foil, and let it rest for 30 minutes. Carve and enjoy some juicy prime rib."
    }
  ]);

  const handleTaskTitle = function(event) {
    setTaskTitle(event.target.value);
  };
  const handleTaskDescription = function(event) {
    setTaskDescription(event.target.value);
  };

  // Add or edit task form
  const addeditTaskForm = function(event) {
    event.preventDefault();
    if (taskTitle === "") {
      showStatusMessage("Please enter task title");
      document.frm_task.task_title.focus();
    } else if (taskDescription === "") {
      showStatusMessage("Please enter task description");
      document.frm_task.task_description.focus();

    } else if (!toggleAddEditTask) { // edit task
      setTasks(
        tasks.map(function(task) {
          if (task.id === taskToBeEdited) {
            return { ...task, title: taskTitle, description: taskDescription };
          }
          return task;
        })
      );
      
      setShowAddEditForm(false);
      setTaskTitle("");
      setTaskDescription("");
      showStatusMessage(false);
      setToggleAddEditTask(true);
      setShowAddButton(true);

    } else { // add task
      
      const newTask = {
        id: new Date().getTime().toString(), 
        title: taskTitle, 
        description: taskDescription
      };
      setTasks([newTask, ...tasks]);

      setShowAddEditForm(false);
      setTaskTitle("");
      setTaskDescription("");
      showStatusMessage(false);
      setShowAddButton(true);
    }
  };

  // Add task
  const addTask = function() {
    setShowAddEditForm(true);
    setShowAddButton(false);
  };

  // Edit task
  const editTask = function(index) {
    setShowAddEditForm(true);
    setShowAddButton(false);
    
    setToggleAddEditTask(false);
    let currentEditTask = tasks.find(function(task) {
      return task.id === index;
    });
    setTaskTitle(currentEditTask.title);
    setTaskDescription(currentEditTask.description);
    setTaskToBeEdited(index);
  };

  // Delete task
  const deleteTask = function(index) {
    const updatedTasks = tasks.filter(function(task) {
      return index !== task.id;
    });
    setTasks(updatedTasks);
  };

  return (
    <>
      <form name="frm_task" id="frm_task" onSubmit={addeditTaskForm}>
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-md-6">
            {showAddEditForm ? (
              <>
                <Card className="my-3">
                  <Card.Header className="fs-5 bg-secondary-subtle">
                    {toggleAddEditTask ? "Add New Task" : "Edit Task"}
                  </Card.Header>
                  <Card.Body>
                    <div className="row">
                      <div className="col-md-5 my-2">
                        <FloatingLabel controlId="task_title" label="Title">
                          <Form.Control 
                            type="text" 
                            name="task_title" 
                            id="task_title" 
                            value={taskTitle} 
                            onChange={handleTaskTitle} 
                            placeholder="Title" 
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-md-5 my-2">
                        <FloatingLabel controlId="task_description" label="Description">
                          <Form.Control 
                            type="text" 
                            name="task_description" 
                            id="task_description" 
                            value={taskDescription} 
                            onChange={handleTaskDescription} 
                            placeholder="Description" 
                          />
                        </FloatingLabel>
                      </div>
                      <div className="col-md-2 my-2 d-grid">
                        <Form.Control type="submit" value={toggleAddEditTask ? "Add" : "Save"} className="btn btn-success btn-lg" />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </>
            ) : (
              ""
            )} {/* end showAddEditForm */}

            <div className="form-text text-danger">{statusMessage}</div>

            {showTaskList ? (
              <>
                <ListGroup as="ul" className="my-3">
                  <ListGroup.Item as="li" variant="success" className="d-flex justify-content-between align-items-center">
                    <div className="fs-5">React Task List</div>
                    {showAddButton ? (
                      <>
                        <Button variant="success" size="sm" onClick={() => addTask()}>Add New Task</Button>
                      </>
                      ) : (
                        ""
                      )} {/* end showAddButton */}
                  </ListGroup.Item>

                  {tasks.map(function(task, index) {
                    return (
                      <>
                        <ListGroup.Item as="li" className="d-flex justify-content-between align-items-center" key={task.id}>
                          <div>
                            <div className="fw-bold">{task.title}</div>
                            {task.description}
                          </div>
                          {toggleAddEditTask ? (
                            <>
                              <div className="d-flex gap-1 ms-3">
                                <Button variant="outline-primary" size="sm" onClick={() => editTask(task.id)}>Edit</Button>
                                <Button variant="outline-danger" size="sm" onClick={() => deleteTask(task.id)}>Delete</Button>
                              </div>
                            </>
                          ) : (
                            ""
                          )} {/* end toggleAddEditTask */}
                        </ListGroup.Item>
                      </>
                    );
                  })}

                  {(tasks.length === 0) ? (
                    <>
                      <ListGroup.Item as="li" className="d-flex justify-content-center">No current tasks</ListGroup.Item>
                    </>
                  ) : (
                    ""
                  )}
                </ListGroup>
              </>
            ) : (
              ""
            )} {/* end showTaskList */}
          </div>
        </div>
      </div>
      </form>
    </>
  );
}

export default Task;